import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

/**
 * The spinner component `<trp-spinner>` is a facade around the `mat-spinner` component.
 * Its only purpose is to provide an easy way to customize the color!
 * The `mat-spinner` only understand palettes, which is sort of a nightmare.
 * With the `trp-spinner`, you can customize the color via a CSS variable: `--spinner-color`.
 */
@Component({
  selector: 'trp-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SpinnerComponent {
  /**
   * The diameter, size, of the spinner, in pixels. Defaults to `20`
   */
  @Input() diameter: MatProgressSpinner['diameter'] = 20;
}
